// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.additionalInfo__eG52o {
  grid-column: 3;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
}
.additionalInfo__eG52o .checkboxHigh__FIbO8 {
  border: 1px solid var(--labels-outline-stroke-text-high);
}
.additionalInfo__eG52o .checkboxHigh__FIbO8 div {
  background-color: var(--labels-outline-stroke-text-high);
}
.additionalInfo__eG52o .checkboxStandard__VANzF {
  border: 1px solid var(--labels-outline-stroke-text-standard);
}
.additionalInfo__eG52o .checkboxStandard__VANzF div {
  background-color: var(--labels-outline-stroke-text-standard);
}
.additionalInfo__eG52o .checkboxCritical__Yk34u {
  border: 1px solid var(--labels-outline-stroke-text-critical);
}
.additionalInfo__eG52o .checkboxCritical__Yk34u div {
  background-color: var(--labels-outline-stroke-text-critical);
}
@media (max-width: 1300px) {
  .additionalInfo__eG52o {
    grid-column: 1/3;
    display: grid;
    grid-template-columns: 2fr 1fr;
    column-gap: 25px;
  }
}
@media (max-width: 810px) {
  .additionalInfo__eG52o {
    row-gap: 15px;
  }
}

.blockTitle__XyYLG {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.blockContainer__XRV3b {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-top: 10px;
  padding: 20px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}
@media (max-width: 1300px) {
  .blockContainer__XRV3b {
    height: calc(100% - 24px);
  }
}

.skeletonContainer__QTyh6 {
  row-gap: 25px;
}

.skeletonField__T3NXs {
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Profile/components/AdditionalInfo/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAzEF;AA2EE;EACE,wDAAA;AAzEJ;AA2EI;EACE,wDAAA;AAzEN;AA6EE;EACE,4DAAA;AA3EJ;AA6EI;EACE,4DAAA;AA3EN;AA+EE;EACE,4DAAA;AA7EJ;AA+EI;EACE,4DAAA;AA7EN;AAiFE;EA9BF;IA+BI,gBAAA;IACA,aAAA;IACA,8BAAA;IACA,gBAAA;EA9EF;AACF;AAgFE;EArCF;IAsCI,aAAA;EA7EF;AACF;;AAgFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,qDAAA;EACA,wCAAA;AA7EF;AA+EE;EATF;IAUI,yBAAA;EA5EF;AACF;;AA+EA;EACE,aAAA;AA5EF;;AA+EA;EACE,YAAA;AA5EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.additionalInfo {\n  grid-column: 3;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n\n  .checkboxHigh {\n    border: 1px solid var(--labels-outline-stroke-text-high);\n\n    div {\n      background-color: var(--labels-outline-stroke-text-high);\n    }\n  }\n\n  .checkboxStandard {\n    border: 1px solid var(--labels-outline-stroke-text-standard);\n\n    div {\n      background-color: var(--labels-outline-stroke-text-standard);\n    }\n  }\n\n  .checkboxCritical {\n    border: 1px solid var(--labels-outline-stroke-text-critical);\n\n    div {\n      background-color: var(--labels-outline-stroke-text-critical);\n    }\n  }\n\n  @media (max-width: 1300px) {\n    grid-column: 1/3;\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    column-gap: 25px;\n  }\n\n  @media (max-width: 810px) {\n    row-gap: 15px;\n  }\n}\n\n.blockTitle {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.blockContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n  margin-top: 10px;\n  padding: 20px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n\n  @media (max-width: 1300px) {\n    height: calc(100% - 24px);\n  }\n}\n\n.skeletonContainer {\n  row-gap: 25px;\n}\n\n.skeletonField {\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"additionalInfo": `additionalInfo__eG52o`,
	"checkboxHigh": `checkboxHigh__FIbO8`,
	"checkboxStandard": `checkboxStandard__VANzF`,
	"checkboxCritical": `checkboxCritical__Yk34u`,
	"blockTitle": `blockTitle__XyYLG`,
	"blockContainer": `blockContainer__XRV3b`,
	"skeletonContainer": `skeletonContainer__QTyh6`,
	"skeletonField": `skeletonField__T3NXs`
};
module.exports = ___CSS_LOADER_EXPORT___;
